import Header from './components/Header';
import HeroSection from './components/HeroSection';
import SectionsPart1 from './components/SectionsPart1';
import SectionsPart2 from './components/SectionsPart2';
import SectionsPart3 from './components/SectionsPart3';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="relative min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <SectionsPart1 />
        <SectionsPart2 />
        <SectionsPart3 />
      </main>
      <Footer />
    </div>
  );
}